import { application } from "./application"

import MembershipFormController from "./membership_form_controller"
application.register("membership-form", MembershipFormController)